import axios from 'axios';
import Cookies from 'js-cookie'; // Import js-cookie

export const baseUrl = 'https://api.atcef.com/';

const getToken = (): string | null => {
  const authToken = Cookies.get('authToken');  // Get token from cookies
  if (!authToken) {
    console.warn('Auth token not found in cookies');
    return null;
  }
  return authToken;
};

// Axios instance with baseURL and common headers
const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor to add Authorization header before each request
axiosInstance.interceptors.request.use(
  (config) => {
    const excludedRoutes = ['/api/v1/participants/signup', '/api/v1/participants/login', '/api/v1/participants/emailTokenVerification'];
    const requestUrl = new URL(config.url || '', config.baseURL).pathname;

    if (!excludedRoutes.includes(requestUrl)) {
      const token = getToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
